import { render, staticRenderFns } from "./Categoria_editar.vue?vue&type=template&id=a8a2b494"
import script from "./Categoria_editar.vue?vue&type=script&lang=js"
export * from "./Categoria_editar.vue?vue&type=script&lang=js"
import style0 from "./Categoria_editar.vue?vue&type=style&index=0&id=a8a2b494&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports